import { State } from './pairing.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectPairingState = createFeatureSelector<State>('pairing');

export const isVerifyingCode = createSelector(selectPairingState, (state) => state.isVerifyingCode);

export const isCodeInvalid = createSelector(selectPairingState, (state) => state.isCodeValidated && !state.isCodeValid);

export const isCodeVvalid = createSelector(selectPairingState, (state) => state.isCodeValidated && state.isCodeValid);

export const isEnrolling = createSelector(selectPairingState, (state) => state.isEnrolling);

export const isEnrollmentCompleted = createSelector(selectPairingState, (state) => state.isEnrollmentCompleted);

export const selectPairChallenge = createSelector(selectPairingState, (state) => state.pairChallenge);

export const selectError = createSelector(selectPairingState, (state) => state.error);
